import { render, staticRenderFns } from "./CertificateForm.vue?vue&type=template&id=1223ce2f"
import script from "./CertificateForm.vue?vue&type=script&lang=js"
export * from "./CertificateForm.vue?vue&type=script&lang=js"
import style0 from "./CertificateForm.vue?vue&type=style&index=0&id=1223ce2f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports